document.getElementById('continentDropdown').addEventListener('change', filterDistributors);
document.getElementById('countryDropdown').addEventListener('change', filterDistributors);
console.log('here')
function filterDistributors() {
    const selectedContinent = document.getElementById('continentDropdown').value;
    const selectedCountry = document.getElementById('countryDropdown').value;

    const distributors = document.querySelectorAll('[data-continent][data-country]');

    distributors.forEach((distributo) => {
        const continent = distributo.getAttribute('data-continent');
        const country = distributo.getAttribute('data-country');

        const shouldShow =
            (selectedContinent === 'All' || selectedContinent === continent) &&
            (selectedCountry === 'All' || selectedCountry === country);

        distributo.style.display = shouldShow ? 'block' : 'none';
    });
}
